import app from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAxe2WNDf1ZYAi7t7_CQNwCNuo0ZGh5Py0",
  authDomain: "app-inmobiliaria-2.firebaseapp.com",
  databaseURL: "https://app-inmobiliaria-2.firebaseio.com",
  projectId: "app-inmobiliaria-2",
  storageBucket: "app-inmobiliaria-2.appspot.com",
  messagingSenderId: "413016679835",
  appId: "1:413016679835:web:09db32334b7749795c2d3e",
  measurementId: "G-43YQ6533X1"
};

class Firebase {
  constructor() {
    app.initializeApp(firebaseConfig);
    this.db = app.firestore();
    this.auth = app.auth();
    this.storage = app.storage();
    //para habilitar el captcha de login por telefono del componente PhoneLogin
    this.authorization = app.auth;
    //crear una extension de firebase para guardar multiples documentos - el referancia a guardar las imagenes de los inmuebles en el componente newestate
    //se pasa un array de fotos (documents) y va a retornar un array de urls, con la ubicacion de cada foto
    this.storage.ref().constructor.prototype.saveDocuments = function(documents) {
      let ref = this;
      return Promise.all(
        documents.map(function(file) {
          return ref
            .child(file.alias)
            .put(file)
            .then(snapshot => {
              return ref.child(file.alias).getDownloadURL();
            });
        })
      );
    };
  }

  //Funcion que cambia el estado si se ha inicializado el servicio de firebase en App.jsx
  //Firebase se va a ejecutar cuando este inicializado
  isInitialize() {
    return new Promise(resolve => {
      this.auth.onAuthStateChanged(resolve);
    });
  }
  //para componente userProfile
  //para el storage de firebase para guardar cualquier documento
  saveDocument = (nameDoc, doc) =>
    this.storage
      .ref()
      .child(nameDoc)
      .put(doc);
  //devuelve la url de donde esta almacenado el documento en firebase
  //se utiliza la libreria de react / npm i --save react-images-upload
  urlDoc = docUrl =>
    this.storage
      .ref()
      .child(docUrl)
      .getDownloadURL();
  //del constructor de firebase de saveDocuments() para guardar imagenes de cada inmueble del componente newstate
  //para almacenar las direcciones de las urls de las imagenes en la bbddd
  saveDocuments = documents => this.storage.ref().saveDocuments(documents);
  //metodo de la funcion deletePhoto del componente EditEstate para eliminar fotos añadidas a la edicion
  deleteDocument = document => this.storage.ref().child(document).delete();
}

export default Firebase;
